'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const utils = require('../utils.js');

var number = {
  test: function (v) {
    return typeof v === 'number';
  },
  parse: parseFloat,
  transform: function (v) {
    return v;
  }
};
var alpha = tslib.__assign(tslib.__assign({}, number), {
  transform: utils.clamp(0, 1)
});
var scale = tslib.__assign(tslib.__assign({}, number), {
  default: 1
});

exports.alpha = alpha;
exports.number = number;
exports.scale = scale;
